import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import { fetchRoles } from "./api";
import type { Role } from "./api";

// Список встроенных ролей с их default/эффективным промптом, моделью и
// наличием override'ов. Не realtime — обновление через
// invalidateQueries после save/reset.
export function useAgentRoles(): UseQueryResult<readonly Role[], Error> {
  return useOrgScopedQuery<readonly Role[]>({
    key: ["agent-roles", "list"],
    queryFn: () => fetchRoles(),
    retry: false,
  });
}
